const researchData = []

export default researchData
